import {FinzyFee} from './FinzyFee';
import {LoanDues} from './loan-dues';

export class LoanRestructure {
    public loanId: string;
    public status: LoanRestructureStatus;
    public upfrontPaymentTotal: number;
    public upfrontPaymentPrincipal: number;
    public upfrontPaymentInterest: number;
    public upfrontPaymentDate: Date;
    public principal: number;
    public capitalizedInterestRestructure: number;
    public capitalizedInterestInPrincipal: number;
    public tenureInMonths: number;
    public yearlyRoiInPercentage: number;
    public firstEmiDueDate: Date;
    public restructuringFee: FinzyFee;
    public agencyFee: FinzyFee;
    public restructuredOn: Date;
    public oldPrincipalOutstanding: number;
    public oldTenureInMonths: number;
    public oldYearlyRoiInPercentage: number;
    public firstDelayedEmiDueOn: Date;
    public oldEmiAmount: number;
    public duesBeforeRestructure: LoanDues;
}

export enum LoanRestructureStatus {
    restructuringReceived = 'restructuringReceived', complete = 'complete', failed = 'failed'
}
